import * as React from "react";
const LogoColor = (props) => (
    <svg
        width={256}
        height={207}
        viewBox="0 0 256 207"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="m67.88 140.812-16.85.646-.543 6.394 3.126 7.815 8.631 51.023h7.516zm71.627-6.469-16.792 1.788 5.038 12.52 5.037 55.444h6.717z"
            fill="#008C95"
        />
        <path
            d="m162.252 84.73 93.746 108.167h-64.901l-52.282-52.281-88.336 7.211 3.605-73.913H0L25.24 45.07 70.31 0z"
            fill="#008C95"
        />
        <path
            d="M64.589 32.713c-10.334 2.584-22.39 12.27-23.251 14.854 2.799 3.66 18.86 10.85 29.71 10.334 10.85-.517 23.681-10.119 27.126-14.21-5.813-3.874-23.251-13.561-33.585-10.978"
            fill="#fff"
        />
        <path
            d="M76.858 43.282c0 4.637-8.212 12.27-13.563 12.27-5.35 0-12.917-5.696-12.917-10.333s5.63-11.625 10.98-11.625 15.5 5.05 15.5 9.688"
            fill="#008C95"
        />
    </svg>
);
export default LogoColor;
